var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label label-despatch-badge"},[_c('i',{class:['fas', _vm.despatchIcon, 'mr-1']}),_vm._v(" "+_vm._s(_vm._f("formatLookupName")(_vm.type,_vm.DespatchTypeLookup)))])}
var staticRenderFns = []

export { render, staticRenderFns }